var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"request-status",attrs:{"aria-live":"polite","aria-busy":!_vm.error}},[_c('p',[_vm._v(_vm._s(_vm.error ? '資料載入失敗，請稍後再試。' : '資料載入中，請稍候…'))]),(_vm.error)?_c('button',{attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('retry')}}},[_vm._v("重新載入")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }